import { tepiTersembunyi } from './tepi'

/**
 * tepiGeser: a ref callback for a row that scrolls sideways (filter chips, the family card's
 * tabs on a phone, the tables of Tambah entri's ceremony flow). It marks which edges hide content as `data-tepi`
 * ("kiri", "kanan" or "kiri kanan"; tepiTersembunyi decides) so a utility in globals.css fades
 * that edge (`geser-tepi` both, `geser-kanan` the right one only): the fade is what says "there
 * is more this way". Set straight on the element on scroll and on resize (no React state, so
 * scrolling renders nothing); React 19 runs the returned cleanup when the element goes. Use as
 * `ref={tepiGeser}`.
 */
export function tepiGeser(el: HTMLElement | null): (() => void) | undefined {
  return el === null ? undefined : pasangTepi(el, 'x')
}

/**
 * tepiGulir: the same for a column that scrolls up and down (the side panel's navigation over
 * its Akun block): "atas", "bawah" or "atas bawah", faded by `gulir-bawah` (the bottom only).
 */
export function tepiGulir(el: HTMLElement | null): (() => void) | undefined {
  return el === null ? undefined : pasangTepi(el, 'y')
}

const NAMA_TEPI = { x: ['kiri', 'kanan'], y: ['atas', 'bawah'] } as const

function pasangTepi(el: HTMLElement, sumbu: 'x' | 'y'): () => void {
  const [namaAwal, namaAkhir] = NAMA_TEPI[sumbu]
  const tandai = () => {
    const { awal, akhir } =
      sumbu === 'x'
        ? tepiTersembunyi(el.scrollLeft, el.clientWidth, el.scrollWidth)
        : tepiTersembunyi(el.scrollTop, el.clientHeight, el.scrollHeight)
    const tepi = [awal ? namaAwal : '', akhir ? namaAkhir : ''].filter(Boolean).join(' ')
    if (tepi === '') delete el.dataset.tepi
    else if (el.dataset.tepi !== tepi) el.dataset.tepi = tepi
  }
  tandai()
  el.addEventListener('scroll', tandai, { passive: true })
  // The box's own size and its items' (a chip grows when a filter is chosen, a group of the
  // navigation when the panel widens).
  const observer = new ResizeObserver(tandai)
  observer.observe(el)
  for (const child of Array.from(el.children)) observer.observe(child)
  return () => {
    el.removeEventListener('scroll', tandai)
    observer.disconnect()
  }
}
